// products.js
import { setProducts } from "./../store/slices/product-slice";
import { store } from "./../store/store";

const fetchProducts = (user) => {
  try {
    // Check if user are available
    if (user) {
      // Retrieve productsData from user
      const productsData = user.productsData;

      // Check if productsData is an object
      if (typeof productsData === "object" && productsData !== null) {
        // Convert the object values to an array
        const productsArray = Object.values(productsData);

        // Format the products data
        const formattedProductsData = productsArray.map((product) => {
          // Check if product.createdAt is defined and is an object with toDate function
          const createdAt =
            product.createdAt && typeof product.createdAt.toDate === "function"
              ? product.createdAt.toDate().toLocaleString()
              : null;

          return {
            ...product,
            createdAt,
          };
        });

        // Update the Redux store with the formatted data
        store.dispatch(setProducts(formattedProductsData));
      } else {
        // If productsData is not an object, set products to null in the Redux store
        store.dispatch(setProducts(null));
      }
    } else {
      // Log an error if user is not available
      console.error("User not authenticated.");
    }
  } catch (error) {
    // Log and rethrow the error for further handling
    console.error("Error in fetchProducts:", error);
    throw error;
  }
};

export default fetchProducts;
